import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

// const grid = document.querySelector('.gallery-container');
// if (grid) {
//   const gutter = parseFloat(getComputedStyle(grid).getPropertyValue('--gutter')) || 20;
//   imagesLoaded(grid, () => {
//     const msnry = new Masonry(grid, {
//       itemSelector: '.gallery-item',
//       columnWidth: '.gallery-sizer',
//       gutter: gutter,
//       percentPosition: true,
//       originLeft: true
//     });
//     imagesLoaded(grid).on('progress', () => msnry.layout());
//     window.addEventListener('resize', () => msnry.layout());
//   });
// }

import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

const galleryMarqueeElsArr = document.querySelectorAll(
    '.gallery-marquee-container'
);

if (galleryMarqueeElsArr.length) {
  galleryMarqueeElsArr.forEach((marqueeEl, idx) => {
    const marquee = new CometMarquee(marqueeEl, {
      speed: 50,
      adaptivePause: true,
      reverse: idx % 2 === 1,
      pauseOnInvisible: true,
      initialShift: true,
    });
  });
}

/*
const galleryGridEl = document.querySelector('.gallery-grid');
if (galleryGridEl) {
  const galleryImagesArr = galleryGridEl.querySelectorAll('.gallery-image');

  galleryImagesArr.forEach((galleryImage, idx) => {
    if(idx === 0 && galleryImage.classList.contains('gallery-image--w3-4')) {
      galleryImage.classList.remove('gallery-image--w3-4');
    }
  })
}
*/
